module.exports = __webpack_public_path__ + "static/media/da_interactive_space_animation.737eb825.png";